import { createFileRoute, Outlet, redirect, useLoaderData } from '@tanstack/react-router';
import { TopBar } from '../../layout/top-bar';
import { Toaster } from 'react-hot-toast';
import { getRoles } from '@/people';
import { getCompanies } from '@/company';
import LoadingScreen from '@/layout/loading-screen';
import * as Sentry from "@sentry/react";

// This is the root layout for the dashboard, which includes the top bar and the outlet for child routes.
// It is used to render the top bar and the content of the matched child route.
// The Toaster component is used to display notifications at the top center of the screen.
export const Route = createFileRoute('/(app)/_layout')({
  component: DashboardLayout,
  //loader: requireAuth,
  // beforeLoad: async ({ context }) => {
  //   const user = await context.userManager.getUser();
  //   if (!user || user.expired) {
  //     return redirect({ to: '/auth/login' }); // Redirect to login if user is not authenticated
  //   }
  // },
  loader: async () => {
    const roleData = await getRoles();
    const companiesData = await getCompanies();
    if(roleData.error || companiesData.error) {
      Sentry.captureException(roleData.error || companiesData.error, {
        tags: {
          source: 'dashboard-layout-loader',
        },
      });
      throw redirect({ to: '/error' });

    }
    return {roleData, companiesData};
  },
  staleTime: 1000 * 60 * 120, // 120 minutes
  shouldReload: false,
  pendingComponent: () => <LoadingScreen />
})

export default function DashboardLayout() {

  const { roleData } = useLoaderData({ from: '/(app)/_layout' });
  return (
    <div>
      <Toaster position='top-center' />
      <TopBar roles={roleData.data!!} />
      <Outlet /> {/* Renders the matched child route */}
    </div>
  );
}